"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/tag/style/index.js
// module id = 482
// module chunks = 1